@if (visible()) {
<div
    @slideIn
    class="pwa-install-prompt fixed inset-x-0 bottom-0 z-999 flex justify-center px-3 pb-[calc(0.75rem_+_env(safe-area-inset-bottom,_0px))] print:hidden sm:inset-x-auto sm:right-6 sm:justify-end"
    role="dialog"
    aria-label="Installer l'espace client"
>
    <div
        class="pointer-events-auto w-full max-w-lg rounded-2xl border border-solewa-gray bg-solewa-white p-4 shadow-lg sm:max-w-md"
    >
        <div class="flex items-start gap-3">
            <img
                class="h-11 w-11 shrink-0 rounded-xl"
                src="assets/icons/pwa/icon-96.png"
                alt=""
            />

            <div class="min-w-0 flex-auto">
                <p class="font-semibold text-solewa-black">
                    Installer l'espace client
                </p>
                <p class="mt-0.5 text-sm text-solewa-neutral-gray">
                    Ajoutez l'application à votre écran d'accueil pour un accès
                    direct, même avec une connexion instable.
                </p>
            </div>

            <button
                mat-icon-button
                class="-mr-2 -mt-2 shrink-0"
                aria-label="Masquer cette invitation"
                (click)="dismiss()"
            >
                <mat-icon
                    class="icon-size-5"
                    [svgIcon]="'heroicons_outline:x-mark'"
                ></mat-icon>
            </button>
        </div>

        @if (showIosSteps()) {
        <ol
            class="mt-3 space-y-2 rounded-xl bg-solewa-light-blue p-3 text-sm text-solewa-black"
        >
            <li class="flex items-center gap-2">
                <span
                    class="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-solewa-white"
                >
                    <mat-icon
                        class="icon-size-4 text-solewa-blue"
                        [svgIcon]="'heroicons_outline:arrow-up-on-square'"
                    ></mat-icon>
                </span>
                <span>Touchez le bouton Partager de Safari</span>
            </li>
            <li class="flex items-center gap-2">
                <span
                    class="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-solewa-white"
                >
                    <mat-icon
                        class="icon-size-4 text-solewa-blue"
                        [svgIcon]="'heroicons_outline:plus'"
                    ></mat-icon>
                </span>
                <span>Choisissez « Sur l'écran d'accueil »</span>
            </li>
            <li class="flex items-center gap-2">
                <span
                    class="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-solewa-white"
                >
                    <mat-icon
                        class="icon-size-4 text-solewa-blue"
                        [svgIcon]="'heroicons_outline:check'"
                    ></mat-icon>
                </span>
                <span>Confirmez avec « Ajouter »</span>
            </li>
        </ol>
        }

        <div class="mt-3 flex items-center justify-end gap-2">
            <button
                mat-button
                class="min-h-11"
                type="button"
                (click)="dismiss()"
            >
                Plus tard
            </button>
            <button
                mat-button
                class="solewa-button-secondary min-h-11"
                type="button"
                (click)="install()"
            >
                <mat-icon
                    class="icon-size-5 mr-1 text-solewa-white"
                    [svgIcon]="
                        ios()
                            ? 'heroicons_outline:arrow-up-on-square'
                            : 'heroicons_outline:arrow-down-tray'
                    "
                ></mat-icon>
                {{ ios() ? 'Voir la marche à suivre' : 'Installer' }}
            </button>
        </div>
    </div>
</div>
}
